module.exports = "/fonts/segoe-ui-italic.ttf";